// extracted by mini-css-extract-plugin
module.exports = {"header-wrap":"screen-header_header-wrap_3eiV-","header-title":"screen-header_header-title_bpmcl","back":"screen-header_back_1nbFG","name":"screen-header_name_kZVrN"};